import Vue from "vue";
import "@mdi/font/css/materialdesignicons.css"; // Ensure you are using css-loader
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import "./registerServiceWorker";
import firebase from "firebase";
import vuefire from "vuefire";
import { store } from "./store";
import Gravatar from "vue-gravatar";
import * as VueGoogleMaps from 'vue2-google-maps'

if (!firebase.apps.length) {
  const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyBnuZJIuRvweJ_qX4ZEmQCe2cerF92RCz4",
    authDomain: "tfgr-9ed26.firebaseapp.com",
    databaseURL: "https://tfgr-9ed26.firebaseio.com",
    projectId: "tfgr-9ed26",
    storageBucket: "tfgr-9ed26.appspot.com",
    messagingSenderId: "47742064305"
  });
}


Vue.use(vuefire);
Vue.config.productionTip = false;
Vue.component("v-gravatar", Gravatar);
Vue.use(VueGoogleMaps, {
  load: {
    // Your personal API key.
    // Get it here: https://console.cloud.google.com/google/maps-apis
    key: "AIzaSyDekWQKPXzyQXGX5OBCzQs2hvlvgHp3vxs",
    libraries: "places,drawing,visualization" // This is required if you use the Autocomplete plugin
  }
});

const unsubscribe = firebase.auth().onAuthStateChanged(firebaseUser => {
  new Vue({
    store,
    router,
    render: h => h(App),
    created() {
      if (firebaseUser) {
        store.dispatch("autoSignIn", firebaseUser);
      }
    }
  }).$mount("#app");
  unsubscribe();
});
